export function getParams(options) {
  if (!options) return;
  let params = [];
  Object.entries(options).forEach(([key, value]) => {
    if (value) params.push(`${key}=${value}`);
  });
  return params.join("&");
}
